import React from "react";

const PayDebt = () => {
  return <div>PENDIENTE</div>;
};

export default PayDebt;
